// ─── SEEDS INITIAUX — Données de démarrage pour la suite RGPD ─────────────────

import { buildFallbackCategoriesWithStyles } from "../../shared/organizationCategories";

export const initialPersonnes = [
  { id: 1, prenom: "Sophie", nom: "Bernard", habilitation: "DPO", fonction: "Déléguée à la Protection des Données", email: "s.bernard@company.fr", perimetre: "Conformité RGPD globale" },
  { id: 2, prenom: "Alexandre", nom: "Moreau", habilitation: "CTO", fonction: "Directeur Technique", email: "a.moreau@company.fr", perimetre: "Infrastructure & Sécurité SI" },
  { id: 3, prenom: "Isabelle", nom: "Renard", habilitation: "DG", fonction: "Directrice Générale", email: "i.renard@company.fr", perimetre: "Validation stratégique" },
  { id: 4, prenom: "Marc", nom: "Fontaine", habilitation: "Juriste", fonction: "Responsable Juridique", email: "m.fontaine@company.fr", perimetre: "Contrats & DPA sous-traitants" },
  { id: 5, prenom: "Claire", nom: "Petit", habilitation: "RSSI", fonction: "Responsable Sécurité SI", email: "c.petit@company.fr", perimetre: "Sécurité technique & audits" },
];

export const initialCategories = buildFallbackCategoriesWithStyles();

export const initialActivites = [
  {
    id: 1,
    intitule: "Rédaction et signature DPA OVH",
    categorie: "Sous-traitance",
    description: "Négociation, rédaction et signature de l'accord de traitement avec OVH SAS (art. 28 RGPD). Vérification des clauses obligatoires et du périmètre de traitement.",
    responsableId: 4,
    preuveRef: "DPA – Hébergement OVH Cloud",
    docTypes: ["DPA"],
    periodicite: "Ponctuelle / renouvellement contrat",
    echeance: "2026-09-01",
  },
  {
    id: 2,
    intitule: "Conduite du PIA Newsletter PrestaShop",
    categorie: "Documentation",
    description: "Réalisation de l'analyse d'impact pour le traitement email marketing via PrestaShop et Mailchimp. Identification des risques, mesures correctrices et validation formelle.",
    responsableId: 1,
    preuveRef: "PIA – Base newsletter PrestaShop × Mailchimp",
    docTypes: ["PIA", "SCC", "TIA"],
    periodicite: "Annuelle ou en cas de changement",
    echeance: "2025-06-30",
  },
  {
    id: 3,
    intitule: "Mise à jour du registre des traitements",
    categorie: "Gouvernance",
    description: "Révision et mise à jour du ROPA (Record of Processing Activities) pour intégrer les nouveaux traitements, modifier les bases légales ou supprimer les traitements obsolètes.",
    responsableId: 1,
    preuveRef: "",
    docTypes: ["ROPA"],
    periodicite: "Semestrielle",
    echeance: "2025-07-01",
  },
  {
    id: 4,
    intitule: "Activation des CCT Mailchimp (transfert hors UE)",
    categorie: "Transferts",
    description: "Mise en place des clauses contractuelles types EU 2021/914 avec Mailchimp/Intuit pour encadrer le transfert de données vers les USA. Inclut TIA préalable.",
    responsableId: 4,
    preuveRef: "PIA – Base newsletter PrestaShop × Mailchimp",
    docTypes: ["SCC", "TIA"],
    periodicite: "Ponctuelle",
    echeance: "2025-06-30",
  },
  {
    id: 5,
    intitule: "Validation stratégique du dossier conformité",
    categorie: "Gouvernance",
    description: "Revue et approbation par la Direction Générale de l'état de conformité RGPD global. Arbitrage des ressources et décisions sur les écarts non conformes.",
    responsableId: 3,
    preuveRef: "",
    docTypes: ["ROPA"],
    periodicite: "Annuelle",
    echeance: "2025-12-31",
  },
  {
    id: 6,
    intitule: "Audit de sécurité infrastructure cloud",
    categorie: "Infrastructure & hébergement",
    description: "Vérification technique de la sécurité de l'hébergement OVH : chiffrement, accès, journalisation, plan de reprise. Alerte en cas de violation de données.",
    responsableId: 5,
    preuveRef: "DPA – Hébergement OVH Cloud",
    docTypes: ["DPA"],
    periodicite: "Annuelle",
    echeance: "2025-09-01",
  },
];

export const initialSousTraitants = [
  {
    id: 1,
    nom: "OVH SAS",
    pays: "France",
    horsEEE: false,
    typeService: "Hébergement cloud & infrastructure",
    donneestraites: "Données clients, BDD production, sauvegardes",
    baseLegale: "Contrat (art. 6(1)(b))",
    niveauRisque: "Faible",
    dpaStatut: "Signé",
    dpaDate: "2023-09-01",
    dpaEcheance: "2026-09-01",
    responsableId: 2,
    sccRequis: false,
    sccStatut: "",
    tiaStatut: "",
    commentaires: "Hébergement 100% EU, datacenter Gravelines (FR) et Roubaix (FR). Certifié ISO 27001.",
    preuveRef: "DPA – Hébergement OVH Cloud",
  },
  {
    id: 2,
    nom: "Mailchimp / Intuit Inc.",
    pays: "USA",
    horsEEE: true,
    typeService: "Plateforme emailing & marketing automation",
    donneestraites: "Adresses email, préférences marketing, historique clics",
    baseLegale: "Consentement (art. 6(1)(a))",
    niveauRisque: "Élevé",
    dpaStatut: "À signer",
    dpaDate: "",
    dpaEcheance: "2025-06-30",
    responsableId: 4,
    sccRequis: true,
    sccStatut: "Non activées",
    tiaStatut: "À réaliser",
    commentaires: "⚠ Transfert hors EEE vers USA. CCT EU 2021/914 non encore activées. TIA préalable obligatoire. Risque élevé en l'état actuel.",
    preuveRef: "PIA – Base newsletter PrestaShop × Mailchimp",
  },
  {
    id: 3,
    nom: "Stripe Inc.",
    pays: "USA",
    horsEEE: true,
    typeService: "Paiement en ligne & gestion des transactions",
    donneestraites: "Données bancaires (tokenisées), identité acheteur, historique achats",
    baseLegale: "Exécution du contrat (art. 6(1)(b))",
    niveauRisque: "Modéré",
    dpaStatut: "Signé",
    dpaDate: "2024-01-15",
    dpaEcheance: "2026-01-15",
    responsableId: 4,
    sccRequis: true,
    sccStatut: "Activées (DPA Stripe)",
    tiaStatut: "Réalisé",
    commentaires: "Stripe dispose de CCT intégrées dans son DPA standard. TIA réalisé : niveau de protection adéquat (Privacy Shield successeur + mesures techniques). PCI-DSS niveau 1.",
    preuveRef: "",
  },
  {
    id: 4,
    nom: "Google Workspace (Google LLC)",
    pays: "USA",
    horsEEE: true,
    typeService: "Suite bureautique cloud (email, docs, agenda)",
    donneestraites: "Emails professionnels, documents internes, contacts",
    baseLegale: "Intérêt légitime (art. 6(1)(f))",
    niveauRisque: "Modéré",
    dpaStatut: "Signé",
    dpaDate: "2023-03-01",
    dpaEcheance: "2025-03-01",
    responsableId: 2,
    sccRequis: true,
    sccStatut: "Activées (DPA Google)",
    tiaStatut: "Réalisé",
    commentaires: "DPA Google Workspace inclut CCT. Renouvellement annuel à surveiller. Stockage EU possible (configurer dans Admin Console).",
    preuveRef: "",
  },
];

export const initialProofs = [
  {
    id: 1, intitule: "DPA – Hébergement OVH Cloud", categorie: "Sous-traitance", docType: "DPA",
    description: "Accord de traitement des données conclu avec OVH SAS pour l'hébergement des serveurs de production et des sauvegardes. OVH agit en qualité de sous-traitant au sens de l'art. 28 RGPD.",
    dateCreation: "2023-09-01", derniereMaj: "2025-01-10", responsableId: 2,
    registre: "Registre sous-traitants v2", politique: "Cartographie IT 2024 – Infrastructure cloud",
    traitements: "Hébergement web, BDD clients, Sauvegardes automatisées",
    statutVerif: "Conforme", dateVerif: "2025-01-15", verifPar: "CTO – Alexandre Moreau",
    commentaires: "DPA signé, clause art. 28 présente. Hébergement 100% EU (Gravelines). Aucun transfert hors EEE.",
    statut: "Validé", version: "v1.2", dateValidation: "2025-01-20", validePar: "DPO – Sophie Bernard",
    observations: "Renouvellement à prévoir – échéance sept. 2026.",
  },
  {
    id: 2, intitule: "PIA – Base newsletter PrestaShop × Mailchimp", categorie: "Documentation", docType: "PIA",
    description: "Analyse d'impact pour la collecte d'adresses email via PrestaShop et leur transfert vers Mailchimp (sous-traitant US) à des fins de communications commerciales.",
    dateCreation: "2024-03-20", derniereMaj: "2024-11-05", responsableId: 1,
    registre: "Registre traitements marketing – #07", politique: "PSI 2024 – Flux de données sortants",
    traitements: "Newsletter clients, Campagnes email, Segmentation comportementale",
    statutVerif: "Écart", dateVerif: "2024-11-10", verifPar: "DPO – Sophie Bernard",
    commentaires: "⚠ Mailchimp (Intuit) basé aux USA : transfert hors EEE. CCT EU 2021/914 à vérifier. Opt-in à renforcer.",
    statut: "Non conforme", version: "v1.0", dateValidation: "", validePar: "",
    observations: "Actions : (1) Activer CCT Mailchimp, (2) MAJ module consentement PrestaShop, (3) Mention transfert hors UE. Deadline Q2 2025.",
  },
];

export const initialTraitements = [
  {
    id: 1,
    nom: "Gestion de la relation client (CRM)",
    finalite: "Gestion clients/prospects",
    baseLegale: "Contrat (art. 6(1)(b))",
    description: "Gestion des comptes clients, historique des commandes, préférences, support client, facturation.",
    categoriesDonnees: ["Identité", "Coordonnées", "Données financières", "Vie professionnelle"],
    categoriesPersonnes: ["Clients", "Prospects"],
    originesDonnees: "Formulaires web, commandes, emails, téléphone, compte client",
    destinataires: ["Services internes", "Sous-traitants"],
    destinatairesDetail: "Service commercial, comptabilité, support. Sous-traitants : Salesforce (CRM), Stripe (paiement)",
    transfertsHorsUE: false,
    transfertsDetail: "",
    dureeConservation: "Durée du contrat + X ans",
    dureeDetail: "Pendant la relation commerciale + 3 ans après dernière commande (prescription)",
    mesuresSecurite: ["Chiffrement", "Contrôle d'accès", "Sauvegardes", "Formation utilisateurs"],
    mesuresDetail: "Chiffrement TLS, accès limité par rôle, sauvegarde quotidienne, formation annuelle RGPD",
    responsableId: 1,
    sousTraitantsConcernes: "Salesforce Inc., Stripe Inc.",
    risque: "Modéré",
    piaRealise: false,
    dateCreation: "2023-05-10",
    derniereMaj: "2024-12-15",
    observations: "Traitement principal de l'activité. Vérifier régulièrement les accès.",
  },
  {
    id: 2,
    nom: "Newsletter marketing via Mailchimp",
    finalite: "Marketing/Newsletter",
    baseLegale: "Consentement (art. 6(1)(a))",
    description: "Envoi de communications commerciales (newsletters, promotions) aux clients et prospects ayant donné leur consentement opt-in.",
    categoriesDonnees: ["Identité", "Coordonnées"],
    categoriesPersonnes: ["Clients", "Prospects"],
    originesDonnees: "Formulaire d'inscription newsletter (site web, PrestaShop)",
    destinataires: ["Services internes", "Sous-traitants"],
    destinatairesDetail: "Service marketing. Sous-traitant : Mailchimp/Intuit (plateforme emailing)",
    transfertsHorsUE: true,
    transfertsDetail: "Transfert vers USA (Mailchimp/Intuit). CCT EU 2021/914 à activer. TIA à réaliser.",
    dureeConservation: "3-5 ans",
    dureeDetail: "3 ans à compter du dernier consentement ou de la dernière interaction",
    mesuresSecurite: ["Chiffrement", "Contrôle d'accès"],
    mesuresDetail: "Double opt-in, lien de désinscription, chiffrement HTTPS, accès limité équipe marketing",
    responsableId: 1,
    sousTraitantsConcernes: "Mailchimp / Intuit Inc.",
    risque: "Élevé",
    piaRealise: true,
    dateCreation: "2024-03-01",
    derniereMaj: "2024-11-05",
    observations: "⚠ Non conforme : transfert hors UE sans CCT activées. Action corrective Q2 2025.",
  },
  {
    id: 3,
    nom: "Gestion RH & Paie",
    finalite: "RH/Paie",
    baseLegale: "Contrat (art. 6(1)(b))",
    description: "Gestion administrative du personnel : contrats, paie, congés, formation, évaluations, dossiers médicaux (médecine du travail).",
    categoriesDonnees: ["Identité", "Coordonnées", "Données financières", "Vie professionnelle", "Données de santé (sensibles)"],
    categoriesPersonnes: ["Employés", "Candidats"],
    originesDonnees: "Candidatures, contrats, déclarations employés, médecine du travail",
    destinataires: ["Services internes", "Sous-traitants", "Organismes sociaux"],
    destinatairesDetail: "Direction, RH, comptabilité. Sous-traitants : logiciel de paie (Sage). Organismes : URSSAF, caisse retraite, mutuelle",
    transfertsHorsUE: false,
    transfertsDetail: "",
    dureeConservation: "5-10 ans",
    dureeDetail: "Pendant la relation de travail + 5 ans après départ (prescription prud'homale). Bulletins de paie : 50 ans",
    mesuresSecurite: ["Chiffrement", "Contrôle d'accès", "Pseudonymisation", "Journalisation", "Sauvegardes"],
    mesuresDetail: "Accès strict (RH uniquement), chiffrement base de données, pseudonymisation des stats RH, logs d'accès",
    responsableId: 1,
    sousTraitantsConcernes: "Sage SAS",
    risque: "Élevé",
    piaRealise: true,
    dateCreation: "2023-01-15",
    derniereMaj: "2024-10-20",
    observations: "Données sensibles (santé). PIA validé. Accès très restreints.",
  },
];

export const initialPointsCollecte = [
  {
    id: 1,
    nom: "Formulaire newsletter site web",
    type: "Inscription newsletter",
    finalites: ["Newsletter marketing", "Prospection commerciale"],
    modaliteRecueil: "Double opt-in (confirmation email)",
    libelleExact: "En cochant cette case, j'accepte de recevoir la newsletter hebdomadaire et les offres promotionnelles de [Société]. Je peux me désinscrire à tout moment via le lien présent dans chaque email.",
    preuveConsentement: "Horodatage de la soumission du formulaire + clic sur le lien de confirmation email. IP et user-agent enregistrés. Version de la politique de confidentialité acceptée (v2.1 du 15/01/2024).",
    outilsImpliques: "PrestaShop (module newsletter), Mailchimp",
    responsableId: 1,
    traitementROPA: "Newsletter marketing via Mailchimp",
    observations: "Double opt-in obligatoire. Case pré-cochée interdite. Lien de désinscription présent dans chaque email.",
    dateCreation: "2024-01-15",
    derniereMaj: "2024-11-05",
  },
  {
    id: 2,
    nom: "Bandeau cookies site web",
    type: "Cookies / Traceurs",
    finalites: ["Cookies analytics", "Cookies publicitaires"],
    modaliteRecueil: "Bandeau cookies",
    libelleExact: "Ce site utilise des cookies pour améliorer votre expérience et réaliser des statistiques de visite. Vous pouvez accepter, refuser ou personnaliser vos choix.",
    preuveConsentement: "Enregistrement du choix utilisateur (accepter/refuser/personnaliser) dans le cookie 'consent_status' avec timestamp. Durée de validité : 13 mois. Outil : OneTrust CMP.",
    outilsImpliques: "OneTrust (CMP), Google Analytics, Google Ads",
    responsableId: 2,
    traitementROPA: "",
    observations: "Conforme ePrivacy. Refus aussi facile que l'acceptation. Révocable à tout moment via lien 'Gérer mes cookies' en footer.",
    dateCreation: "2023-09-01",
    derniereMaj: "2024-10-12",
  },
  {
    id: 3,
    nom: "Création compte client e-commerce",
    type: "Création compte client",
    finalites: ["Prospection commerciale", "Notifications push"],
    modaliteRecueil: "Opt-in simple (case à cocher)",
    libelleExact: "☐ Je souhaite recevoir les offres personnalisées et nouveautés par email (optionnel)",
    preuveConsentement: "État de la case à cocher enregistré en BDD (champ 'marketing_consent' boolean). Date et heure de la création du compte. Version CGU acceptée.",
    outilsImpliques: "PrestaShop, CRM Salesforce",
    responsableId: 1,
    traitementROPA: "Gestion de la relation client (CRM)",
    observations: "Case NON pré-cochée (conforme RGPD). Consentement distinct de la création du compte (granularité respectée).",
    dateCreation: "2023-05-10",
    derniereMaj: "2024-06-20",
  },
];

export const initialRetraits = [
  {
    id: 1,
    personne: "Marie Dupont (marie.dupont@example.com)",
    dateReception: "2025-01-15",
    canal: "Lien désinscription email",
    pointsCollecteConcernes: "Formulaire newsletter site web",
    consentementsConcernes: ["Newsletter marketing", "Prospection commerciale"],
    actionsMener: "Suppression de l'adresse email de la liste Mailchimp. Mise à jour du statut 'unsubscribed' dans PrestaShop. Vérification que l'email ne reçoit plus de communications.",
    responsableId: 1,
    statut: "Traitée",
    dateTraitement: "2025-01-15",
    observations: "Traitement immédiat (automatique). Email de confirmation envoyé.",
  },
  {
    id: 2,
    personne: "Jean Martin (jean.martin@example.com)",
    dateReception: "2025-02-01",
    canal: "Email DPO",
    pointsCollecteConcernes: "Création compte client e-commerce, Formulaire newsletter site web",
    consentementsConcernes: ["Prospection commerciale", "Newsletter marketing"],
    actionsMener: "Désactivation du flag 'marketing_consent' dans le CRM. Suppression de Mailchimp. Vérification complète de l'absence de communications futures.",
    responsableId: 1,
    statut: "En cours de traitement",
    dateTraitement: "",
    observations: "Demande manuelle reçue par email. Traitement en cours, confirmation prévue sous 48h.",
  },
];

export const initialPSSI = {
  charteUtilisateurs: "Les utilisateurs doivent respecter la charte d'usage des SI. Les mots de passe doivent être complexes (12 caractères min, majuscules, chiffres, caractères spéciaux) et changés tous les 90 jours. Aucun partage de compte autorisé.",
  gestionAcces: "Principe du moindre privilège appliqué. Accès accordés sur demande validée par le manager + DSI. Révision trimestrielle des habilitations. Déprovisionnement immédiat en cas de départ.",
  classificationDonnees: "3 niveaux : Public (libre diffusion), Interne (usage interne uniquement), Confidentiel (accès restreint, chiffrement obligatoire). Données RGPD = min. Interne.",
  sauvegardes: "Sauvegardes quotidiennes automatiques (rétention 30j). Sauvegardes hebdomadaires (rétention 1 an). Tests de restauration trimestriels. Stockage sur site distant chiffré.",
  gestionIncidents: "Procédure : Détection → Confinement → Éradication → Récupération → Retour d'expérience. Escalade : L1 (Help Desk) → L2 (DSI) → L3 (RSSI) → Direction si critique.",
  formationSensibilisation: "Formation RGPD annuelle obligatoire pour tous. Formation sécurité SI pour profils techniques (2x/an). Campagnes phishing trimestrielles. Rappels mensuels par newsletter.",
  supervision: "Logs centralisés (conservation 1 an). Monitoring 24/7 des événements critiques. Alertes automatiques (tentatives intrusion, accès anormaux). Revue hebdomadaire des logs.",
  gestionPostes: "Antivirus à jour obligatoire. Pare-feu activé. Mises à jour système automatiques. Chiffrement disque dur (BitLocker/FileVault). Verrouillage auto après 10 min inactivité.",
  politique: "Approuvée par la Direction le 15/01/2024. Revue annuelle obligatoire. Diffusée à tous les collaborateurs. Accessible sur l'intranet. Non-respect = sanction disciplinaire.",
};

export const initialElementsSI = [
  {
    id: 1, nom: "Serveur Web Production", type: "Serveur virtuel", localisation: "Cloud public (AWS/Azure/GCP)",
    localisationDetail: "AWS Paris (eu-west-3)", criticite: "Critique",
    donneesHebergees: "Site web public, formulaires de contact, fichiers statiques",
    responsableTechnique: 2, sousTraitantConcerne: "Amazon Web Services (AWS)",
    mesuresSecurite: ["Pare-feu", "Chiffrement", "Sauvegardes", "Monitoring"],
    derniereMAJ: "2024-11-15", observations: "RTO : 4h, RPO : 1h. Sauvegardes quotidiennes.",
  },
  {
    id: 2, nom: "Base MySQL - Clients", type: "Base de données", localisation: "Hébergeur externe",
    localisationDetail: "OVH Roubaix RBX-A", criticite: "Critique",
    donneesHebergees: "Données clients B2C : identité, emails, historique commandes, préférences",
    responsableTechnique: 2, sousTraitantConcerne: "OVH SAS",
    mesuresSecurite: ["Chiffrement", "Contrôle d'accès", "Sauvegardes", "Journalisation"],
    derniereMAJ: "2025-01-10", observations: "Chiffrement au repos (AES-256). Accès VPN uniquement.",
  },
];

export const initialPRA = {
  dateApprobation: "2024-01-15",
  dateRevision: "2025-01-15",
  rtoGlobal: "24h",
  rpoGlobal: "4h",
  scenarios: [
    {
      id: 1, type: "Cyberattaque / Ransomware", description: "Chiffrement des données par ransomware, serveurs inaccessibles",
      procedures: "1. Isolation immédiate du réseau\n2. Activation cellule de crise\n3. Analyse forensique (sous-traitant)\n4. Restauration depuis sauvegardes (RTO : 12h)\n5. Notification CNIL sous 72h si données personnelles",
      rto: "12h", rpo: "1h", responsable: 2, derniereMAJ: "2024-10-15",
    },
    {
      id: 2, type: "Panne matérielle", description: "Défaillance serveur principal hébergeant la BDD clients",
      procedures: "1. Bascule automatique sur serveur secondaire (failover)\n2. Vérification intégrité données\n3. Notification équipe technique\n4. Remplacement matériel sous 24h (contrat maintenance OVH)",
      rto: "4h", rpo: "15min", responsable: 2, derniereMAJ: "2024-11-20",
    },
  ],
  contactsUrgence: "DSI : +33 6 12 34 56 78\nRSSI : +33 6 98 76 54 32\nHébergeur OVH : 1007\nAssurance : +33 1 23 45 67 89",
  testsRealises: [
    { date: "2024-06-15", scenario: "Restauration BDD depuis sauvegarde", resultat: "Succès — RTO respecté (3h30)", observations: "Procédure validée" },
    { date: "2024-09-20", scenario: "Simulation ransomware + bascule failover", resultat: "Partiel — RTO dépassé (6h)", observations: "Améliorer procédure isolation réseau" },
  ],
};

export const initialIncidents = [
  {
    id: 1,
    titre: "Accès non autorisé à la base emails Mailchimp",
    type: "Accès non autorisé",
    gravite: "Majeure",
    statut: "En cours d'analyse",
    dateDetection: "2025-01-28",
    dateNotifCnil: "",
    delai72h: true,
    responsableId: 1,
    sousTraitantConcerne: "Mailchimp / Intuit Inc.",
    donneesImpactees: "Listes email clients newsletter (~12 000 contacts), préférences marketing",
    nbPersonnesConcernees: "12000",
    descriptionIncident: "Accès API non autorisé détecté sur le compte Mailchimp via clé API compromise. Données potentiellement exfiltrées. Investigation en cours avec l'équipe technique.",
    mesuresPrises: "Révocation immédiate de la clé API compromise. Audit des accès en cours. Notification aux personnes concernées en attente de l'analyse d'impact.",
    notifPersonnes: false,
    observations: "Analyse d'impact en cours. Décision de notification CNIL à prendre sous 72h à compter de la détection.",
  },
  {
    id: 2,
    titre: "Erreur d'envoi — données clients exposées à tiers",
    type: "Erreur humaine",
    gravite: "Modérée",
    statut: "Notifié CNIL",
    dateDetection: "2024-11-05",
    dateNotifCnil: "2024-11-07",
    delai72h: true,
    responsableId: 1,
    sousTraitantConcerne: "",
    donneesImpactees: "Noms, emails, historique de commandes (38 clients)",
    nbPersonnesConcernees: "38",
    descriptionIncident: "Fichier CSV contenant des données clients envoyé par erreur à un prestataire non habilité lors d'une migration de données. Détecté par le prestataire qui a signalé l'incident.",
    mesuresPrises: "Suppression confirmée du fichier par le prestataire. Notification CNIL effectuée dans les 72h. Notification individuelle aux 38 clients concernés.",
    notifPersonnes: true,
    observations: "Clôture prévue après retour CNIL. Procédure d'envoi de fichiers renforcée.",
  },
];

export const initialDroits = [
  {
    id: 1, type: "Accès (art. 15)", statut: "Complétée", canal: "Email",
    dateReception: "2024-10-15", dateEcheance: "2024-11-14", dateReponse: "2024-11-02",
    responsableId: 1, identiteDecouverte: false,
    description: "Demande d'accès à l'ensemble des données personnelles collectées via le site e-commerce.",
    reponse: "Dossier complet envoyé par email chiffré : données de compte, historique commandes, préférences marketing.",
    observations: "",
  },
  {
    id: 2, type: "Effacement (art. 17)", statut: "En cours", canal: "Formulaire web",
    dateReception: "2025-01-20", dateEcheance: "2025-02-19", dateReponse: "",
    responsableId: 1, identiteDecouverte: true,
    description: "Demande de suppression totale du compte et de toutes les données associées. Client ayant exercé son droit d'opposition préalablement.",
    reponse: "",
    observations: "Vérification en cours : données en cours de traitement actif (commande en attente de livraison). Délai légal courant.",
  },
  {
    id: 3, type: "Portabilité (art. 20)", statut: "Reçue", canal: "Email",
    dateReception: "2025-02-01", dateEcheance: "2025-03-03", dateReponse: "",
    responsableId: 1, identiteDecouverte: false,
    description: "Demande d'export de toutes les données dans un format structuré et lisible par machine (JSON ou CSV).",
    reponse: "",
    observations: "Identité à vérifier. Génération du fichier d'export à préparer.",
  },
];

export const initialProcessusDroits = {
  conforme: false,
  workflow: "",
  validateurs: [],
  emailConfirmation: "",
};
